import { Typography } from "@material-ui/core";
import { useState } from "react";
import * as theme from "../theme";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { OrangeButton } from "../general/OrangeButton";
import { useDispatch } from "react-redux";
import { updatePassword } from "../store/passwordManagement";
import { loginModalOpened } from "../store/components";
import { useNavigate } from "react-router-dom";
const PasswordManagement = (props) => {
  const [isPassword, setIsPassword] = useState(false);
  const url = window.location.pathname.split("/");
  const token = window.location.search.split("?id=")[1];
  let history = useNavigate();
  const dispatch = useDispatch();
  const signUp = url[1].includes("signup");
  const validationSchema = Yup.object().shape({
    password: Yup.string()
      .required("Password is required")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\^$*.\[\]{}\(\)?\-\"!@#%&\/,><\':;|_~`])\S{8,20}$/,
        "Must be 8-20 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
      ),
    confirmPassword: Yup.string()
      .required("Confirm Password is required")
      .oneOf([Yup.ref("password")], "Passwords must match"),
  });
  const formOptions = { resolver: yupResolver(validationSchema) };

  // get functions to build form with useForm() hook
  const { register, handleSubmit, reset, formState } = useForm(formOptions);
  const { errors } = formState;

  function onSubmit(data) {
    // display form data on success
    dispatch(
      updatePassword({
        updatedpassword: data.password,
        token: token,
      })
    );
    history("/");
    // dispatch(loginModalOpened());
    return false;
  }

  return (
    <div
      style={{
        height: "100%",
        paddingLeft: "1rem",
        backgroundColor: theme.COLORS.question_area_bg,
      }}
    >
      {!signUp && (
        <>
          <Typography
            variant="h5"
            style={{
              fontFamily: "GibsonSemiBd",
              fontSize: "5vmin",
              color: theme.COLORS.primary_navyblue,
              paddingTop: "2rem",
            }}
          >
            Resetting Your Password
          </Typography>
          <Typography
            style={{
              fontSize: 15,
              fontFamily: "GibsonRegular",
            }}
          >
            Resetting your password is quick and easy. Just follow the
            instructions below and you will be good to go!
          </Typography>
        </>
      )}
      <Typography
        variant="h5"
        style={{
          fontFamily: "GibsonSemiBd",
          fontSize: "5vmin",
          color: theme.COLORS.secondary_skyblue,
          paddingTop: "2rem",
        }}
      >
        Set up your new password
      </Typography>
      <Typography
        style={{
          fontSize: 15,
          fontFamily: "GibsonRegular",
        }}
      >
        Please set-up a confidential and secure password which you can use to
        access Quotey.
        <br />
        Your password must be at least 8 characters long, include at least one
        of each of the following characters:
        <ul>
          <li>Lower case letter</li>
          <li>Upper case letter</li>
          <li>Number</li>
          <li>{"Special character @!#$%^&*()"}</li>
        </ul>
      </Typography>
      <form
        style={{ display: "flex", flexDirection: "column" }}
        onSubmit={handleSubmit(onSubmit)}
      >
        <div
          style={{
            width: "50%",
            display: "grid",
            gridTemplateColumns: "repeat(2,1fr)",
            margin: "1rem 0",
          }}
        >
          <label>Your Password:</label>
          <input
            name="password"
            type="password"
            {...register("password")}
            className={`form-control ${errors.password ? "is-invalid" : ""}`}
          />
          <div className="invalid-feedback">{errors.password?.message}</div>
        </div>
        <div
          style={{
            width: "50%",
            display: "grid",
            gridTemplateColumns: "repeat(2,1fr)",
            margin: "1rem 0",
          }}
        >
          <label>Confirm Password:</label>
          <input
            name="confirmPassword"
            type="password"
            {...register("confirmPassword")}
            className={`form-control ${
              errors.confirmPassword ? "is-invalid" : ""
            }`}
          />
          <div className="invalid-feedback">
            {errors.confirmPassword?.message}
          </div>
        </div>
        <OrangeButton
          disable={isPassword}
          type="submit"
          width="50%"
          style={{ fontWeight: "700" }}
          fontSize="2.5vmin"
          text="Confirm and take me to Quotey!"
        ></OrangeButton>
      </form>
    </div>
  );
};
export default PasswordManagement;
